import React, { useCallback, useContext, useEffect, useReducer, useState } from 'react'
import { defaultReducer } from '../../Utils/reducers'
import { api } from '../../../services/api'
import { getSession } from '../../../contexts/auth'
import { toast } from 'react-hot-toast'
import { Box, TextField } from '@mui/material'
import { PhoneInput } from '../../Utils/MaskedInput'

import './styles.css'
import ColorButton from '../../Buttons/ColorButton'
import apptheme from '../../theme/default'
import SaveIcon from '@mui/icons-material/Save';
import { externalComponent } from '../../AppRoutes'
import PasswordIcon from '@mui/icons-material/Password';
import ChangePassword from './change-password'

const changePassword = async(newPassword, close) => {
    const res = await api.post(`/profile/change/`, {password:newPassword})
    if (res.status === 200){
        toast.success('Senha alterada com sucesso!')
        close()
        return
    }
    else if (res.status === 400){
        toast.error(res.data.join('\n'))
        return
    }
    toast.error('A senha não foi alterada pois ocorreu um erro.')
}

const Profile = () => {

    const { setLoader } = useContext(externalComponent)

    const [showPasswordDialog, setShowPasswordDialog] = useState(false)

    const user = getSession()
    const groups =localStorage.getItem('grupo')

    return (
        <>
            {showPasswordDialog && <ChangePassword ChangePassword={(data) => changePassword(data, () => setShowPasswordDialog(false))} handleClose={() => setShowPasswordDialog(false)}/>}
                <>
                    <Box sx={{display:'flex', gap:'1rem'}}>
                        {/* <ColorButton
                            className='profile-save-button'
                            onClick={() => saveData(state)}
                            fColor={apptheme.tertiaryColor}
                            sColor={apptheme.primaryColor}>
                            <Box className='flexbox'><SaveIcon /> Salvar</Box>
                        </ColorButton> */}
                        <ColorButton
                            className='profile-save-button'
                            onClick={() => setShowPasswordDialog(true)}
                            fColor={apptheme.tertiaryColor}
                            sColor={apptheme.primaryColor}>
                            <Box className='flexbox'><PasswordIcon /> Trocar senha</Box>
                        </ColorButton>
                    </Box>
                    <Box className='profile-overflow'>
                        <Box className='item-content-modal' sx={{padding:'1rem'}} >
                            <TextField
                                id="clientname"
                                type="text"
                                sx={{ backgroundColor: 'white' }}
                                label="Nome do usuário"
                                size='small'
                                defaultValue={user.Descricao}
                                fullWidth={false}
                                inputProps={{
                                    maxLength: 50
                                }}
                            />

                            <TextField
                                id="clientphone"
                                type="text"
                                sx={{ backgroundColor: 'white' }}
                                label="Telefone"
                                size='small'
                                defaultValue={user.Telefone}
                                fullWidth={false}
                            />

                            <TextField
                                id="clientemail"
                                type="email"
                                sx={{ backgroundColor: 'white' }}
                                label="E-mail"
                                disabled
                                size='small'
                                defaultValue={user.Email}
                                fullWidth={true}
                                inputProps={{
                                    maxLength: 100
                                }}
                            />

                            <TextField
                                multiline
                                id="groups"
                                type="text"
                                sx={{ backgroundColor: 'white' }}
                                label="Grupos"
                                disabled
                                size='small'
                                defaultValue={groups}
                                fullWidth={true}
                            />
                        </Box>
                    </Box>
                </>
        </>
    )
}

export default Profile